export class SmCart {
  /**
   * @type {string}
   */
  SM_CART_COUNT_SELECTOR = '';

  /**
   * Init small Cart
   * @param {string} SM_CART_COUNT_SELECTOR
   */
  constructor(
    SM_CART_COUNT_SELECTOR = '[data-sm-cart-count]',
  ) {
    this.SM_CART_COUNT_SELECTOR = SM_CART_COUNT_SELECTOR;
  }

  /**
   * Set counter of small cart
   * @param {number} count
   */
  update(count) {
    const counter = document.querySelector(this.SM_CART_COUNT_SELECTOR);
    const parent = counter.closest('.header-account-link');
    if (parent !== null) {
      if (count === 0) {
        parent?.classList.add('disabled');
      } else {
        parent?.classList.remove('disabled');
        if (count > 999) {
          parent?.classList.add('many');
        } else {
          parent?.classList.remove('many');
        }
      }
    }
    counter.textContent = count.toString();
    return this;
  }
}
